import LoginHeader from "./LoginHeader";
import LoginForm from "./LoginForm";
import "./login.scss";

const Login = (props) => {
  return (
    <div className="login-wrapper">
      <div className="login-card">
        <LoginHeader />
        <LoginForm {...props} />
      </div>
    </div>
  );
};

export default Login;
